// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"H9-z"};